import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/meh-rolling-eyes': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM336 152C296.2 152 264 184.2 264 224S296.2 296 336 296 408 263.8 408 224 375.8 152 336 152zM336 264C313.9 264 296 246.1 296 224 296 210.4 303.3 198.9 313.7 191.7 312.7 194.3 312 197 312 200 312 213.3 322.7 224 336 224S360 213.3 360 200C360 197.1 359.3 194.3 358.3 191.7 368.7 198.9 376 210.4 376 224 376 246.1 358.1 264 336 264zM232 224C232 184.2 199.8 152 160 152S88 184.2 88 224 120.2 296 160 296 232 263.8 232 224zM120 224C120 210.4 127.3 198.9 137.7 191.7 136.7 194.3 136 197 136 200 136 213.3 146.7 224 160 224S184 213.3 184 200C184 197.1 183.3 194.3 182.3 191.7 192.7 198.9 200 210.4 200 224 200 246.1 182.1 264 160 264S120 246.1 120 224zM312 352H184C170.8 352 160 362.8 160 376S170.8 400 184 400H312C325.2 400 336 389.2 336 376S325.2 352 312 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/meh-rolling-eyes.js
// module id = FnYn
// module chunks = 144